import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import { EldDisconnectionsList } from "./EldDisconnectionsList";

export default {
  icon: ReportProblemOutlinedIcon,
  list: EldDisconnectionsList,
};
